// SETUP HOOK for the e2e suite (e2e/support/solitaire.ts), installed only when the fixtures set
// window.__E2E__ = true before the app loads. A player has no way to choose a deal, so tests need
// this to deal an exact layout; everything else they do through the UI.
import type { GameController } from './engine/controller';
import { uiStore } from './store/uiStore';

export interface SolitaireTestHook {
  /** The next New game uses this shuffle pattern (legacy semantics, rewrite-notes 2.10). */
  dealPattern(pattern: number[]): void;
  dealSizes(): number[];
  deckCardIds(): string[];
  /** The shuffle pattern of the current deal (what a win posts as shuffle_pattern). */
  pattern(): number[];
}

declare global {
  interface Window {
    __E2E__?: boolean;
    __solitaireTest?: SolitaireTestHook;
    /** Opens the Win window with sample numbers (the look of the celebration without finishing a game). */
    __openSampleWin?: () => void;
  }
}

export function installTestHook(ctrl: GameController, requestNewGame: (pattern: number[]) => boolean): void {
  if (!window.__E2E__) return;
  window.__solitaireTest = {
    dealPattern(pattern) {
      if (ctrl.getState().status === 'dealing') throw new Error('dealPattern: a deal is running');
      if (!requestNewGame(pattern)) throw new Error('dealPattern: the game refused a new deal');
    },
    dealSizes: () => ctrl.dealSizes(),
    deckCardIds: () => ctrl.deckCardIds(),
    pattern: () => ctrl.getState().pattern.slice(),
  };
  // The sample win of the UI prototype's switcher (frontend/src/prototype/Switcher.tsx openSampleWin):
  // the real window with the count-up and the ad boxes; it posts the sample win to the local stack only.
  window.__openSampleWin = () => {
    const pattern = Array.from({ length: 52 }, (_, i) => (i * 17 + 5) % 52);
    uiStore().openWindow('win', {
      game: 'klondike:turn-one',
      scoring: 'standard',
      time: 185,
      score: 420,
      moves: 97,
      prevDeal: false,
      pattern,
    });
  };
}
